module.exports = __webpack_public_path__ + "img/292856.3bd01074.svg";